import axios from "../api/axios";
const URL= '/preloader'

const preloader = async () => {
    try {
        const response = await axios
            .get(URL,
                { headers: { 'Content-Type': 'application/json' } }
            );
    } catch (error) {
    }
};

export default preloader;